module.exports = __webpack_public_path__ + "img/DE03033.5611f82d.png";